









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Warning } from '@/pages/profile/components';
import MentoringRequestList from '../../requestslist';
import { REQUEST_WARNING } from '@/pages/profile/modules';
import { IMentoringCompletedRequests, Requests } from './types';

@Component({
  components: {
    Warning,
    MentoringRequestList,
  },
})
export default class MentoringCompletedRequests
  extends Vue
  implements IMentoringCompletedRequests {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Requests;

  warningText: string = REQUEST_WARNING;

  get completedItems(): Requests {
    // Здесь фильтруем по завершенным запросам
    return this.items.filter((item) => item.status === '3');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/views/completedrequests/MentoringCompletedRequests.vue